import React from "react";
var __jsx = React.createElement;
import { Select } from "@mantine/core";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { buildYearOptions } from "./build-year-options";
import { HEADER_SELECT_STYLES } from "./date-field-styles";
var MONTH_OPTIONS = Array.from({
  length: 12
}, function (_, index) {
  return {
    value: String(index),
    label: format(new Date(2000, index, 1), "MMMM")
  };
});

/** Month + year dropdown row that drives the displayed month of the calendar. */
export function CalendarHeader(_ref) {
  var month = _ref.month,
    onMonthChange = _ref.onMonthChange,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    testId = _ref.testId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var yearOptions = buildYearOptions(minDate, maxDate);
  var setMonth = function setMonth(value) {
    if (value === null) return;
    onMonthChange(new Date(month.getFullYear(), Number(value), 1));
  };
  var setYear = function setYear(value) {
    if (value === null) return;
    onMonthChange(new Date(Number(value), month.getMonth(), 1));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-2 flex gap-2"
  }, /*#__PURE__*/React.createElement(Select, {
    size: "xs",
    className: "flex-1",
    "aria-label": t("month", {
      defaultValue: "Month"
    }),
    data: MONTH_OPTIONS,
    value: String(month.getMonth()),
    onChange: setMonth,
    withinPortal: true,
    styles: HEADER_SELECT_STYLES,
    "data-testid": "".concat(testId, "-month")
  }), /*#__PURE__*/React.createElement(Select, {
    size: "xs",
    className: "w-24",
    "aria-label": t("year", {
      defaultValue: "Year"
    }),
    data: yearOptions,
    value: String(month.getFullYear()),
    onChange: setYear,
    searchable: true,
    withinPortal: true,
    maxDropdownHeight: 240,
    styles: HEADER_SELECT_STYLES,
    "data-testid": "".concat(testId, "-year")
  }));
}